import { flow } from 'fp-ts/function';
import { entries, join, map } from 'lodash/fp';
import { DefaultTheme } from 'styled-components';
import { getSpacingToken } from '@optimus-web/common';

const defaultDirectionsMap = {
    '-': '',
    '-t-': '-top',
    '-b-': '-bottom',
    '-l-': '-left',
    '-r-': '-right',
};

const getDefaultSizes = (theme: DefaultTheme) => [
    0,
    getSpacingToken('50')({ theme }),
    getSpacingToken('100')({ theme }),
    getSpacingToken('150')({ theme }),
    getSpacingToken('200')({ theme }),
    getSpacingToken('300')({ theme }),
    getSpacingToken('400')({ theme }),
];

const tag = (dimension: $TSFixMe, key: $TSFixMe, size: $TSFixMe, side: $TSFixMe) =>
    `.${dimension[0]}${key}${size}{ ${dimension}${side}: ${size}px; }`;

export const generateCssSpacings = ({
    directionsMap = defaultDirectionsMap,
    sizes,
    theme,
}: {
    directionsMap?: $TSFixMe;
    sizes?: $TSFixMe;
    theme?: DefaultTheme;
}) => {
    const styles: $TSFixMe = [];
    const finalSizes = sizes || (theme && getDefaultSizes(theme));

    flow(
        entries,
        map(([key, side]) => {
            map((size) => {
                styles.push(tag('margin', key, size, side));
                styles.push(tag('padding', key, size, side));
            })(finalSizes);
        })
    )(directionsMap);

    return join('')(styles);
};
